import script from "./CHeaderMenuLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CHeaderMenuLink.vue?vue&type=script&setup=true&lang=ts"

import "./CHeaderMenuLink.vue?vue&type=style&index=0&id=39d40e32&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_ejoqcbfru5qt7peog562lsj5cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d40e32"]])

export default __exports__